export default __webpack_public_path__ + "static/media/ailogo.5a54d32d.png";